import { LuX } from 'react-icons/lu';
import styles from '../StanMultiSelect.module.css';
import { cn } from '@/lib/utils/cn';

export const TagPill: React.FC<{
    label: string;
    onRemove: () => void;
    showRemove?: boolean;
    disabled?: boolean;
}> = ({ label, onRemove, disabled, showRemove = true }) => (
    <span className={styles.tag}>
        {label}
        {showRemove && (
            <button
                type='button'
                aria-label={`Remove ${label}`}
                onClick={onRemove}
                disabled={disabled}
                className={cn(styles.tagRemove, disabled && styles.tagRemoveDisabled)}
            >
                <LuX className={styles.tagRemoveIcon} />
            </button>
        )}
    </span>
);
